import { Controller } from "@hotwired/stimulus";
import * as common from "@/javascripts/common.js";

// Connects to data-controller="promoters--seller-infos"
export default class extends Controller {
  static targets = ["inquiryEmail", "inquiryPhone", "inquiryUrl"];

  connect() {}

  // 問い合わせ方法変更
  changeInquiryMethod(event) {
    const method = event.currentTarget.value;
    const radioController = this.application.getControllerForElementAndIdentifier(
      document.getElementById("inquiry-method-radio"),
      "radio",
    );
    this.toggleInquiryTargets(method);
    radioController.toggle();
  }

  // 問い合わせ先の表示切り替え
  toggleInquiryTargets(method) {
    common.toggleDisabled(this.inquiryEmailTarget, method === "email");
    common.toggleDisabled(this.inquiryPhoneTarget, method === "phone");
    common.toggleDisabled(this.inquiryUrlTarget, method === "web");
  }
}
